import { useState } from "react";
import styled from "styled-components";
import NameRelationHeader from "./NameRelationHeader";
import ConfirmRequestGridLayout from "./ConfirmRequestGridLayout";

const ConfirmRequestAccordion = ({
  name,
  relation,
  ind,
  data,
  formData,
  pdfNames,
  contactNum,
  isGuestOr,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleClick = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  return (
    <div>
      <NameRelationHeader
        name={name}
        relation={relation}
        index={ind}
        handleClick={handleClick}
        isAccordionOpen={isAccordionOpen}
      />
      <DesktopWrapper>
        <ConfirmRequestGridLayout
          formData={formData}
          data={data}
          pdfNames={pdfNames}
          contactNum={contactNum}
          isGuestOr={isGuestOr}
        />
      </DesktopWrapper>
      {isAccordionOpen && (
        <MobileWrapper>
          <ConfirmRequestGridLayout
            formData={formData}
            data={data}
            pdfNames={pdfNames}
            contactNum={contactNum}
            isGuestOr={isGuestOr}
          />
        </MobileWrapper>
      )}
    </div>
  );
};

const DesktopWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-width: 769px) {
    display: block;
  }
`;

const MobileWrapper = styled.div`
  @media (max-width: 768px) {
    display: block;
  }
  @media (min-width: 769px) {
    display: none;
  }
`;

export default ConfirmRequestAccordion;
